import { hotjar } from 'react-hotjar';

const HJID = 2385738;
const HJSV = 6;
export default function initHotjar() {
  hotjar.initialize(HJID, HJSV);
}
